<div class="root" *transloco="let t; read:'home'" class="root">
    <ng-container *ngIf="data$ | async as data">
        <!-- Welcome message -->
        <div class="root__item">
            <ng-container [ngTemplateOutlet]="message"
                          [ngTemplateOutletContext]="{heading: t('welcomeHeading', { firstName: firstName$ | async }), text: t('welcomeText')}">
            </ng-container>
        </div>

        <!-- Hot work certification puff -->
        <puff class="root__item" *ngIf="data.activeEducationType && data.activeEducationType === educationType.HotWorker"
              [heading]="t('educationPuffCertificationHeading')" [text]="t('educationPuffCertificationText', { organizer: data.organizerName })"
              [url]="getEducationEventUrl(data.currentEducationEventId)" icon="badge-check" layout="swag">
        </puff>

        <!-- Single active education puff -->
        <puff class="root__item" *ngIf="data.activeEducationType && data.activeEducationType !== educationType.HotWorker"
              [heading]="t('educationPuffDefaultHeading')" [text]="t('educationPuffDefaultText', { organizer: data.organizerName })"
              [url]="getEducationEventUrl(data.currentEducationEventId)" icon="users-class" layout="default">
        </puff>

        <!-- Multiple active educations -->
        <puff class="root__item" *ngIf="data.userHasMultipleActiveEvents" [heading]="t('educationPuffMultipleEventsHeading')"
              [text]="t('educationPuffMultipleEventsText')" [url]="getEducationListUrl()" icon="users-class" layout="default">
        </puff>

        <!-- Grundbok Heta Arbeten 2025 -->
        <puff class="root__item" *ngIf="(isExternal$ | async) === false && (data.activeEducationType && data.activeEducationType === educationType.HotWorker || data.userHasMultipleActiveEvents)"
              [text]="t('educationHotWorkerManual')" [url]="'/knowledgebank/dokumentbibliotek'" icon="book" layout="default" [iconColor]="'issuu-orange'">
        </puff>

        <!-- No Certificate puff -->
        <div class="root__item" *ngIf="!(data.activeEducationType && data.activeEducationType === educationType.HotWorker) && !data.userHasCertificate">
            <puff [text]="t('hasNoCertificatePuff')" url="/publiceducationevents" icon="hexagon-exclamation"></puff>
        </div>

        <!-- Certificate Expiration puff -->
        <div class="root__item" *ngIf="data.userHasCertificate && isCertificateExpiring$ | async">
            <puff [text]="t('certificateExpirationPuff')" url="/publiceducationevents" icon="hourglass-clock"></puff>
        </div>

        <!-- Certificate puff -->
        <div class="root__item" *ngIf="data.userHasCertificate">
            <puff [text]="t('certificatePuff')" url="/certificate" icon="address-card"></puff>
        </div>

        <!-- ID06 puff -->
        <puff class="root__item" *ngIf="data.showId06Invite" [text]="t('id06ConsentInvite')" url="/id06consent" icon="cabinet-filing">
        </puff>

        <!-- SSG puff -->
        <puff class="root__item" *ngIf="data.showSSGInvite" [text]="t('ssgConsentInvite')" url="/ssgconsent" icon="skillnation">
        </puff>
    </ng-container>

    <ng-template #message let-heading="heading" let-text="text">
        <div class="message">
            <div class="message__header">
                <div class="message__header__icon"></div>
                <div class="message__header__heading" [innerHTML]="heading"></div>
            </div>
            <div class="message__text" [innerHTML]="text">
            </div>
        </div>
    </ng-template>
</div>
